export const REQUEST_STATISTICS_LAYOUT = {
  detailTableGridColumns: "56px 200px 144px minmax(220px, 1fr) 120px 184px",
  detailTableHeight: 440,
  detailTableMinWidth: 924,
  tableGridColumns: "minmax(200px, 1.2fr) repeat(4, minmax(190px, 1fr))",
  tableMinWidth: 1040,
} as const
